import createComponent, {
  type ElementWithProps
} from '@carvana/merch-components/createComponent';
import cx from 'classnames';

export const DescriptionWrapper = createComponent<
  ElementWithProps<{ shouldDisplayAssetOwnerLayout: boolean }>
>('div', props => ({
  className: cx(
    'my-40 flex flex-col items-center m:p-0',
    props.shouldDisplayAssetOwnerLayout ? 'p-0' : 'px-48'
  )
}));

export const DescriptionTitle = createComponent('div', {
  className: 'pb-12 pt-16 text-center text-blue-6 tl-brand-s m:tl-brand-l'
});

export const DescriptionParagraph = createComponent('div', {
  className: 'text-center text-grey-5 tl-body-m'
});

export const Separator = createComponent('hr', {
  className: 'w-32 border-t-4 border-yellow-2'
});
